(function () {
  if (window.__vmTrack) return;
  window.__vmTrack = 1;

  var URL_ = 'https://docs.google.com/forms/d/e/1FAIpQLScjg09sLH1CTk8ZZmlInInI3B1bcCAvnfnzKLmbuTbET9n1Ow/formResponse';
  var FIELD = 'entry.897262423';
  var VER = 1;
  var nav = navigator;
  var ua = nav.userAgent || '';

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function rid() { return Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4); }
  function cut(s, n) { s = (s == null ? '' : String(s)).replace(/\s+/g, ' ').trim(); return s.length > n ? s.slice(0, n) : s; }
  function qs(name) { try { return new URLSearchParams(location.search).get(name); } catch (e) { return null; } }

  if (qs('vm_notrack') === '1') set('vm_nt', '1');
  if (qs('vm_notrack') === '0') set('vm_nt', '');
  if (get('vm_nt') === '1' || nav.webdriver || /bot|crawl|spider|slurp|lighthouse|headless|preview/i.test(ua)) return;
  if (window.Shopify && Shopify.designMode) return;

  var now = Date.now();
  var vid = get('vm_vid');
  var firstVisit = !vid;
  if (!vid) { vid = rid(); set('vm_vid', vid); }
  var sid = get('vm_sid');
  var lastT = Number(get('vm_sid_t') || 0);
  var srcKey = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid', 'gclid', 'ttclid'].map(qs).join('|');
  var newSession = !sid || now - lastT > 30 * 60 * 1000 || (srcKey.replace(/\|/g, '') !== '' && srcKey !== get('vm_src'));
  if (srcKey.replace(/\|/g, '') !== '') set('vm_src', srcKey);
  if (newSession) {
    sid = rid();
    set('vm_sid', sid);
    set('vm_seq', '0');
    set('vm_visits', String(Number(get('vm_visits') || 0) + 1));
  }
  function touch() { set('vm_sid_t', String(Date.now())); }
  touch();

  var meta = (window.ShopifyAnalytics && ShopifyAnalytics.meta) || {};
  var pageType = (meta.page && meta.page.pageType) || '';
  var prod = meta.product || null;
  var themeRole = (window.Shopify && Shopify.theme && Shopify.theme.role) || '';
  var queue = [];
  var pvid = rid();
  var lastPath = get('vm_last_path') || '';
  set('vm_last_path', location.pathname);

  function ev(e, d) {
    var seq = Number(get('vm_seq') || 0) + 1;
    set('vm_seq', String(seq));
    queue.push({ e: e, t: Date.now(), n: seq, d: d || {} });
    touch();
    if (queue.length >= 20) flush();
  }

  function flush() {
    if (!queue.length) return;
    var batch = {
      v: VER, vid: vid, sid: sid, pv: pvid, path: location.pathname, type: pageType,
      c: (window.Shopify && Shopify.country) || '', th: themeRole, ev: queue.splice(0, queue.length)
    };
    var body = new URLSearchParams();
    body.append(FIELD, JSON.stringify(batch));
    var ok = false;
    try { ok = nav.sendBeacon && nav.sendBeacon(URL_, body); } catch (e) {}
    if (!ok) { try { fetch(URL_, { method: 'POST', mode: 'no-cors', body: body, keepalive: true }); } catch (e) {} }
  }

  function inApp() {
    if (/Instagram/i.test(ua)) return 'instagram';
    if (/FBAN|FBAV|FB_IAB/i.test(ua)) return 'facebook';
    if (/musical_ly|BytedanceWebview|TikTok/i.test(ua)) return 'tiktok';
    if (/Snapchat/i.test(ua)) return 'snapchat';
    if (/Twitter/i.test(ua)) return 'x';
    if (/LinkedInApp/i.test(ua)) return 'linkedin';
    return '';
  }
  function os() {
    if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';
    if (/Android/i.test(ua)) return 'android';
    if (/Mac OS X/i.test(ua)) return 'mac';
    if (/Windows/i.test(ua)) return 'windows';
    return 'other';
  }
  function browser() {
    if (/Edg\//.test(ua)) return 'edge';
    if (/CriOS|Chrome\//.test(ua)) return 'chrome';
    if (/FxiOS|Firefox\//.test(ua)) return 'firefox';
    if (/Safari\//.test(ua)) return 'safari';
    return 'other';
  }
  function refInfo() {
    var r = document.referrer || '';
    if (!r) return '';
    try { var u = new URL(r); if (u.host === location.host) return 'internal'; return u.host + u.pathname; } catch (e) { return cut(r, 120); }
  }
  function utm() {
    var o = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { var v = qs(k); if (v) o[k.slice(4)] = cut(v, 80); });
    ['fbclid', 'gclid', 'ttclid', 'igshid'].forEach(function (k) { if (qs(k)) o[k] = 1; });
    return o;
  }

  function clarity() {
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', 'z4z1e2hhv5');
    var c = window.clarity;
    c('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' });
    c('identify', vid, sid, pvid);
    c('set', 'page_type', pageType || 'other');
    var u = utm();
    if (u.source) c('set', 'utm_source', u.source);
    if (u.medium) c('set', 'utm_medium', u.medium);
    if (inApp()) c('set', 'in_app', inApp());
    if (document.querySelector('.vm-lock')) c('set', 'locked', '1');
  }

  var PX = '1007462415715751';
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
  var handle = (location.pathname.split('/products/')[1] || '').split('/')[0];
  function fb(a, b, c) { if (window.fbq) { try { fbq(a, b, c); } catch (e) {} } }
  function metaPx() {
    var cp = window.Shopify && Shopify.customerPrivacy;
    try { if (cp && cp.marketingAllowed && !cp.marketingAllowed()) return; } catch (e) {}
    (function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fb('init', PX);
    fb('track', 'PageView');
    if (prod) fb('track', 'ViewContent', { content_ids: [String(prod.id)], content_type: 'product_group', content_name: handle, value: prod.variants && prod.variants[0] ? prod.variants[0].price / 100 : 0, currency: cur });
    if (qs('customer_posted') === 'true' && document.querySelector('.vm-lock')) fb('track', 'Lead', { content_name: handle });
  }

  function start() {
    try { clarity(); } catch (e) {}
    try { metaPx(); } catch (e) {}
    if (newSession) {
      var src = { ref: refInfo(), utm: utm(), landing: cut(location.pathname + location.search, 200) };
      var ft = get('vm_ft');
      if (!ft) { set('vm_ft', JSON.stringify({ ref: src.ref, utm: src.utm, landing: src.landing, t: now })); }
      var con = nav.connection || {};
      ev('session_start', {
        ref: src.ref, utm: src.utm, landing: src.landing, first: firstVisit ? 1 : 0,
        visit: Number(get('vm_visits') || 1), ft: firstVisit ? null : JSON.parse(ft || 'null'),
        os: os(), br: browser(), app: inApp(), mob: /Mobi|iPhone|Android/i.test(ua) ? 1 : 0,
        scr: screen.width + 'x' + screen.height, vp: innerWidth + 'x' + innerHeight, dpr: devicePixelRatio || 1,
        lang: nav.language || '', tz: (Intl.DateTimeFormat().resolvedOptions().timeZone) || '',
        net: con.effectiveType || '', ua: cut(ua, 220)
      });
    }
    var pv = { title: cut(document.title, 100), from: lastPath, ref: refInfo(), q: cut(location.search, 160) };
    if (prod) { pv.product = (location.pathname.split('/products/')[1] || '').split('/')[0]; pv.price = prod.variants && prod.variants[0] ? prod.variants[0].price / 100 : null; }
    if (/\/collections\//.test(location.pathname)) pv.collection = location.pathname.split('/collections/')[1].split('/')[0];
    if (document.querySelector('.vm-lock')) pv.locked = 1;
    if (location.pathname === '/challenge') pv.challenge = 1;
    if (qs('customer_posted') === 'true') pv.remind_done = 1;
    ev('page_view', pv);
    wire();
  }

  var clicks = 0, maxScroll = 0, marks = {}, recent = [];
  var filmMs = 0, filmFullMs = 0, filmLoop = 0;
  var activeMs = 0, lastAct = Date.now(), lastTick = Date.now(), startT = Date.now();

  function describe(el) {
    var t = el.closest('a,button,[role=button],summary,label,input,select,textarea') || el.closest('video,img') || el;
    var tag = t.tagName.toLowerCase();
    var o = { tag: tag };
    if (t.id) o.id = cut(t.id, 60);
    var cls = (typeof t.className === 'string' ? t.className : '').split(/\s+/).filter(Boolean).slice(0, 3).join('.');
    if (cls) o.cls = cut(cls, 80);
    if (tag === 'input' || tag === 'textarea' || tag === 'select') { o.name = cut(t.name, 40); o.itype = t.type || ''; if (t.type === 'radio' || t.type === 'checkbox') o.val = cut(t.value, 30); }
    else o.text = cut(t.getAttribute('aria-label') || t.innerText || t.alt || '', 60);
    var href = t.getAttribute && t.getAttribute('href');
    if (href) { try { var u = new URL(href, location.href); o.href = u.host === location.host ? u.pathname : u.host + u.pathname; if (u.host !== location.host) o.out = 1; } catch (e) {} }
    var sec = t.closest('.shopify-section');
    if (sec) o.sec = cut(sec.id.replace('shopify-section-', ''), 60);
    return o;
  }

  function wire() {
    document.addEventListener('click', function (e) {
      clicks++;
      var d = describe(e.target);
      d.x = Math.round(e.clientX / innerWidth * 100);
      d.y = Math.round(e.clientY / innerHeight * 100);
      d.py = Math.round((e.pageY / Math.max(document.documentElement.scrollHeight, 1)) * 100);
      ev('click', d);
      var t = Date.now();
      recent = recent.filter(function (c) { return t - c.t < 800; });
      recent.push({ t: t, x: e.clientX, y: e.clientY });
      var near = recent.filter(function (c) { return Math.abs(c.x - e.clientX) < 40 && Math.abs(c.y - e.clientY) < 40; });
      if (near.length >= 3) { ev('rage_click', { tag: d.tag, text: d.text || d.name || '', sec: d.sec || '' }); recent = []; }
      if (e.target.closest && e.target.closest('[name=checkout],a[href^="/checkout"]')) fb('track', 'InitiateCheckout', { currency: cur });
    }, true);

    var sTimer = 0;
    addEventListener('scroll', function () {
      if (sTimer) return;
      sTimer = setTimeout(function () {
        sTimer = 0;
        var h = Math.max(document.documentElement.scrollHeight - innerHeight, 1);
        var p = Math.min(100, Math.round(scrollY / h * 100));
        if (p > maxScroll) maxScroll = p;
        [25, 50, 75, 90, 100].forEach(function (m) { if (p >= m && !marks[m]) { marks[m] = 1; ev('scroll', { pct: m }); } });
      }, 250);
      act();
    }, { passive: true });

    ['mousemove', 'keydown', 'touchstart', 'pointerdown'].forEach(function (n) { addEventListener(n, act, { passive: true }); });

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.type === 'radio') ev('option', { name: cut(t.name, 40), val: cut(t.value, 30) });
      else if (t && t.tagName === 'SELECT') ev('option', { name: cut(t.name, 40), val: cut(t.value, 30) });
    }, true);

    document.addEventListener('submit', function (e) {
      var f = e.target;
      var action = (f.getAttribute('action') || '').split('#')[0];
      var id = f.id || '';
      if (/\/cart\/add/.test(action)) {
        var vIn = f.querySelector('[name=id]');
        ev('add_to_cart', { product: (location.pathname.split('/products/')[1] || '').split('/')[0], variant: vIn ? vIn.value : '' });
        var vr = prod && prod.variants && vIn ? prod.variants.filter(function (v) { return String(v.id) === String(vIn.value); })[0] : null;
        fb('track', 'AddToCart', { content_ids: [vIn ? String(vIn.value) : ''], content_type: 'product', content_name: handle, value: vr ? vr.price / 100 : 0, currency: cur });
        setTimeout(function () {
          try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _vm_vid: vid, _vm_sid: sid } }) }); } catch (x) {}
        }, 1500);
      } else if (/^VmRemind/.test(id)) {
        ev('remind_submit', {});
      } else {
        ev('form_submit', { action: cut(action, 60), id: cut(id, 60), type: cut((f.querySelector('[name=form_type]') || {}).value, 30) });
      }
    }, true);

    document.addEventListener('toggle', function (e) {
      var t = e.target;
      if (t && t.tagName === 'DETAILS') ev('toggle', { cls: cut(t.className, 60), open: t.open ? 1 : 0 });
    }, true);

    document.addEventListener('copy', function () { ev('copy', {}); });
    document.addEventListener('vm:remind-done', function () { ev('remind_done', {}); fb('track', 'Lead', { content_name: handle }); });

    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var wasOpen = drawer.classList.contains('active');
      new MutationObserver(function () {
        var o = drawer.classList.contains('active');
        if (o && !wasOpen) ev('cart_open', {});
        wasOpen = o;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    if (document.querySelector('[data-vm-film]')) ev('video_play', { src: 'img' });

    var hero = document.querySelector('.vm-tri');
    if (hero && window.IntersectionObserver) {
      filmLoop = window.matchMedia('(max-width: 749px)').matches ? 16.5 : 5.5;
      var heroRatio = 0, lastF = Date.now();
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { heroRatio = e.isIntersecting ? e.intersectionRatio : 0; });
      }, { threshold: [0, 0.1, 0.25, 0.5, 0.75, 0.9, 1] }).observe(hero);
      setInterval(function () {
        var t = Date.now();
        var img = document.querySelector('[data-vm-film]');
        var on = img ? img.complete && img.naturalWidth > 0 : [].some.call(hero.querySelectorAll('video'), function (v) { return !v.paused; });
        if (document.visibilityState === 'visible' && on) {
          if (heroRatio >= 0.5) filmMs += t - lastF;
          if (heroRatio >= 0.9) filmFullMs += t - lastF;
        }
        lastF = t;
      }, 500);
    }
    var vids = [].filter.call(document.querySelectorAll('video'), function (v) { return v.querySelector('source') || v.currentSrc; });
    if (vids.length) {
      var played = false;
      vids.forEach(function (v) { v.addEventListener('playing', function () { if (!played) { played = true; ev('video_play', { src: cut((v.currentSrc || '').split('/').pop().split('?')[0], 80) }); } }, { once: true }); });
      setTimeout(function () { if (!played) ev('video_noplay', { n: vids.length }); }, 6000);
    }

    if (window.IntersectionObserver) {
      var seen = {};
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var el = en.target;
          if (en.isIntersecting) {
            el.__vmT = setTimeout(function () {
              var key = el.__vmKey;
              if (seen[key]) return;
              seen[key] = 1;
              ev('seen', { what: key });
            }, 1000);
          } else if (el.__vmT) { clearTimeout(el.__vmT); }
        });
      }, { threshold: 0.5 });
      var watch = function (sel, keyFn) {
        document.querySelectorAll(sel).forEach(function (el) { el.__vmKey = keyFn(el); io.observe(el); });
      };
      watch('.vm-drop__tile', function (el) { return 'tile:' + ((el.getAttribute('href') || '').split('/products/')[1] || '').split('?')[0]; });
      watch('.vm-lock', function () { return 'lock'; });
      watch('.vm-size-guide', function () { return 'size_guide'; });
      watch('footer, .vm-footer', function () { return 'footer'; });
      watch('[class*="vm-polaroid"], .vm-break', function () { return 'polaroid'; });
    }

    document.querySelectorAll('.vm-drop__tile').forEach(function (el) {
      var h;
      el.addEventListener('mouseenter', function () {
        h = setTimeout(function () { ev('tile_hover', { product: ((el.getAttribute('href') || '').split('/products/')[1] || '').split('?')[0] }); }, 500);
      });
      el.addEventListener('mouseleave', function () { clearTimeout(h); });
    });

    var errs = 0;
    addEventListener('error', function (e) {
      if (errs++ > 4 || !e.message) return;
      ev('js_error', { msg: cut(e.message, 160), src: cut((e.filename || '').split('/').pop(), 80), line: e.lineno || 0 });
    });
    addEventListener('unhandledrejection', function (e) {
      if (errs++ > 4) return;
      ev('js_error', { msg: cut(e.reason && (e.reason.message || e.reason), 160), src: 'promise' });
    });

    perf();
    setInterval(function () { tick(); flush(); }, 15000);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') { leave(); flush(); }
      else { lastTick = Date.now(); }
    });
    addEventListener('pagehide', function () { leave(); flush(); });
  }

  function act() { lastAct = Date.now(); }
  function tick() {
    var t = Date.now();
    if (document.visibilityState === 'visible' && t - lastAct < 30000) activeMs += t - lastTick;
    lastTick = t;
  }

  var lcp = 0, cls = 0, fcp = 0, lastSent = '';
  function perf() {
    try {
      new PerformanceObserver(function (l) { var e = l.getEntries(); if (e.length) lcp = Math.round(e[e.length - 1].startTime); }).observe({ type: 'largest-contentful-paint', buffered: true });
      new PerformanceObserver(function (l) { l.getEntries().forEach(function (e) { if (!e.hadRecentInput) cls += e.value; }); }).observe({ type: 'layout-shift', buffered: true });
      new PerformanceObserver(function (l) { l.getEntries().forEach(function (e) { if (e.name === 'first-contentful-paint') fcp = Math.round(e.startTime); }); }).observe({ type: 'paint', buffered: true });
    } catch (e) {}
  }

  function leave() {
    tick();
    var navT = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var key = Math.round(activeMs / 1000) + ':' + maxScroll + ':' + clicks + ':' + Math.round(filmMs / 1000);
    if (key === lastSent) return;
    lastSent = key;
    ev('page_time', {
      active_s: Math.round(activeMs / 1000), total_s: Math.round((Date.now() - startT) / 1000),
      max_scroll: maxScroll, clicks: clicks,
      film_s: filmLoop ? Math.round(filmMs / 100) / 10 : null, film_full_s: filmLoop ? Math.round(filmFullMs / 100) / 10 : null, film_loop: filmLoop || null,
      lcp: lcp, fcp: fcp, cls: Math.round(cls * 1000) / 1000,
      ttfb: Math.round(navT.responseStart || 0), load: Math.round(navT.loadEventEnd || 0)
    });
  }

  function consentThen(fn) {
    var S = window.Shopify;
    function check() {
      try {
        var cp = S && S.customerPrivacy;
        if (!cp || !cp.analyticsProcessingAllowed || cp.analyticsProcessingAllowed()) return fn();
        document.addEventListener('visitorConsentCollected', function (e) { if (e.detail && e.detail.analyticsAllowed) fn(); }, { once: true });
      } catch (e) { fn(); }
    }
    if (S && S.loadFeatures) {
      try { S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { check(); }); } catch (e) { fn(); }
    } else fn();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { consentThen(start); });
  else consentThen(start);
})();
